import request from '@/utils/request'

// 获取扔垃圾服务配置
export function getGarbageService() {
  return request({
    url: '/homewaste/waste/garbage/detail',
    method: 'get'
  })
}

// 保存扔垃圾服务配置
export function saveGarbageService(data) {
  return request({
    url: '/homewaste/waste/garbage/save',
    method: 'post',
    data: data
  })
}

// 获取收废品服务配置
export function getWasteService() {
  return request({
    url: '/homewaste/waste/waste/detail',
    method: 'get'
  })
}

// 保存收废品服务配置
export function saveWasteService(data) {
  return request({
    url: '/homewaste/waste/waste/save',
    method: 'post',
    data: data
  })
}
